import { EditIcon } from "vega-icons";

import { type CategoryResponse } from "@vega-api/generated/types/categoryResponse";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { useBoolean } from "@vega-core/hooks/useBoolean";
import { m } from "@vega-core/paraglide/messages";

import { EditCategoryModal } from "./EditCategoryModal";

type EditCategoryButtonProps = {
  category: CategoryResponse;
  slaHours?: number;
};

export const EditCategoryButton = ({
  category,
  slaHours,
}: EditCategoryButtonProps) => {
  const {
    value: isModalOpen,
    setTrue: openModal,
    setFalse: closeModal,
  } = useBoolean();

  return (
    <>
      <ThemedButton
        ariaLabel={m.cases_settings_edit_category()}
        dataTestId={`category-edit-${category.id}`}
        icon={<EditIcon />}
        onClick={openModal}
        size="small"
        variant="tertiary"
      />

      {isModalOpen ? (
        <EditCategoryModal
          category={category}
          onClose={closeModal}
          slaHours={slaHours}
        />
      ) : null}
    </>
  );
};
